import { Stack, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InternalPage, Spacer, HomeLink } from 'theSource/components';
import { IdCardsPageResponseDto } from '../types';
import { GET_ID_CARDS_QUERY_KEY } from '../utils';
import { useApiQuery } from 'theSource/utils';
import { IdCardAddLink } from './components';
import { IdCard } from '../components';
import { mapCards } from './utils';

export const MyIdCardsViewPage = () => {
  const {
    data,
    isLoading: isLoadingIdCards,
    isFetching: isReloadingIdCards,
  } = useApiQuery<IdCardsPageResponseDto>({
    queryKey: GET_ID_CARDS_QUERY_KEY,
    endpoint: '/ecards/sync',
    config: {
      timeout: 0, // no timeout for this request due to slow response times when many/big in size id cards are uploaded
    },
  });

  const { t } = useTranslation('pages.idCards');

  const theme = useTheme();

  const pageData = data && mapCards(data.ecards);
  const isLoading = isLoadingIdCards || isReloadingIdCards || !pageData;

  return (
    <InternalPage
      isLoading={isLoading}
      title={t('title')}
      description={t('subtitle')}
      testId="id-cards-view"
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      <Stack spacing={theme.spacing(4)}>
        {pageData?.map((card) => <IdCard key={card.id} card={card} />)}
      </Stack>
      <Spacer height={6} />
      <IdCardAddLink />
    </InternalPage>
  );
};
